import React from 'react'
import {
    Box,
    useTheme,
    Popover,
    PopoverContent,
    PopoverBody,
    Text,
    Image,
    Button,
    Link
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import PropTypes from 'prop-types'
import {useGlobaleContext} from '../../../contexts/globale'
import {getUrl} from '../../../utils/cloudinary-utils'
import {ArrowLinkIcon} from '../../../components/icons'

const HeaderPromoBarDropdown = ({promoData, ref, onClose, brand}) => {
    const {countryISO} = useGlobaleContext()
    const {promoData1, promoData2, promoData3} = promoData || {}
    const {
        app: {commerceAPI}
    } = getConfig()
    const {config} = commerceAPI.promotions || {}

    const theme = useTheme()
    const {baseStyle} = theme.components.ListMenu
    let promoHeaderLink = '',
        promoHeaderLinkText = ''

    try {
        if (config) {
            promoHeaderLink = JSON.parse(config).promoHeaderLink
            promoHeaderLinkText = JSON.parse(config).promoHeaderLinkText
        }
    } catch (e) {
        console.log(e)
    }

    const promoStyle = {
        item: {
            width: {base: '100%', lg: '33%'},
            maxWidth: {base: '100%', lg: '33%'},
            paddingX: {base: '0', lg: '30px'}
        }
    }

    return countryISO === 'US' ? (
        <>
            {(promoData1 || promoData2 || promoData3) && (
                <Box className="promobar-dropdown">
                    <Popover
                        key={brand + '-popover'}
                        isLazy
                        placement={'bottom-start'}
                        initialFocusRef={ref}
                        onClose={onClose}
                        isOpen
                        variant="fullWidth"
                    >
                        <PopoverContent
                            data-testid="popover-menu"
                            {...baseStyle.popoverContent}
                            marginTop="0"
                            width="100%"
                            transform="scaleX(1) !important"
                            borderRadius="0"
                            minHeight="auto"
                            top={{base: '100px', lg: '108px'}}
                        >
                            <PopoverBody
                                {...baseStyle.popoverBody}
                                minHeight={{base: 'auto', lg: '450px'}}
                                maxH="calc(100dvh - 60px)"
                                overflowY="auto"
                                padding="0"
                            >
                                <Box
                                    display="flex"
                                    gap={{base: '50', lg: '0'}}
                                    padding={{base: '50px 30px', lg: '100px 90px 50px'}}
                                    flexDirection={{base: 'column', lg: 'row'}}
                                >
                                    <Image
                                        onClick={onClose}
                                        width="38px"
                                        height="36px"
                                        alt="Cross Icon"
                                        position="absolute"
                                        right={{base: '15px', lg: '60px'}}
                                        zIndex="inherit"
                                        top="5px"
                                        padding="10px"
                                        cursor="pointer"
                                        background="white"
                                        borderRadius="90px"
                                        src={getUrl('UIImages/images/black-cross-icon.svg')}
                                    />
                                    {promoData1 && (
                                        <Box
                                            {...promoStyle.item}
                                            dangerouslySetInnerHTML={{__html: promoData1}}
                                        />
                                    )}
                                    {promoData2 && (
                                        <Box
                                            {...promoStyle.item}
                                            dangerouslySetInnerHTML={{__html: promoData2}}
                                        />
                                    )}
                                    {promoData3 && (
                                        <Box
                                            {...promoStyle.item}
                                            dangerouslySetInnerHTML={{__html: promoData3}}
                                        />
                                    )}
                                </Box>

                                {promoHeaderLink && promoHeaderLinkText && (
                                    <Box padding={{base: '0 30px', lg: '0 120px'}}>
                                        <Text
                                            as="span"
                                            borderTop="1px solid transparent"
                                            display="block"
                                            height="2px"
                                            width="100%"
                                            bg={'gradientMinicartHover'}
                                            marginBottom="20px"
                                        ></Text>
                                        <Button
                                            as={Link}
                                            href={promoHeaderLink}
                                            variant="textWithArrow"
                                            color="black.100"
                                            fontFamily="inter"
                                            iconSpacing="15px"
                                            className="promo-button"
                                            fontSize="14px"
                                            marginBottom="30px"
                                            rightIcon={
                                                <ArrowLinkIcon
                                                    className="button__arrow-icon"
                                                    width="15px"
                                                    height="15px"
                                                    color="black.100"
                                                    transition="transform 0.3s ease-in-out"
                                                />
                                            }
                                        >
                                            {promoHeaderLinkText}
                                        </Button>
                                    </Box>
                                )}
                            </PopoverBody>
                        </PopoverContent>
                    </Popover>
                </Box>
            )}
        </>
    ) : null
}

HeaderPromoBarDropdown.propTypes = {
    promoData: PropTypes.object,
    ref: PropTypes.any,
    onClose: PropTypes.func,
    brand: PropTypes.string
}
export default HeaderPromoBarDropdown
